export enum validation_status {
    none = '',
    success = 'valid',
    warning = 'warning',
    almost = 'almost',
    error = 'required',
}
